import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DatepickerService } from 'app/Shared/Component/datepicker-calendar/datepicker.service';
import { EventTreeService } from 'app/Shared/Component/event-tree/event-tree.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { DataService } from 'app/Shared/Services/data.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompReviewServiceService {
  LastExecutionCompDate: any[] = [];
  isLoadingGeneraterandomSample: boolean = false;
  isLoadingGenerateCustomSample: boolean = false;
  isGenerateCustomSample: boolean = false;
  isRunCompReport: boolean = false;
  disableRunCompReportButton: boolean = true;
  customSampleName: string = "";
  DefaultFilterArray: any = [];
  SampleFilterArray: any = [];
  Limit: any = { 'Start': '0', 'End': '20' };
  CATFieldTypesArrayList: any;
  quickFilterEventTypeArray: any = [];
  defaultCATEvents: any = ["MENO", "MONO", "MEOA", "MOOA"];
  pageName: any = 'Comparative-Review-Report';
  optedApplicationFilter: any = new Object();
  applicationFilters: any=[];
  deaultEventTypeValues: any=[];
  sampleRecordsNotFoundMsg='Sample record(s) not found for the selected criteria, please check and try again.';
  sampleRecordsFoundMsg='Sample has been created,\n Continue with the “Run Comparative Report” to generate sample output.';
  reportGenerationTimeMsg ='Comparative Review is in progress. Please check back later.'
  


  constructor(
    private readonly gridService: GridService,
    public constantService: ConstantService,
    public dataService: DataService,
    public eventTreeService: EventTreeService,
    public userService: UserService,
    private readonly datepickerService: DatepickerService,
    private readonly emitterService: EmitterService,
    private readonly messageService: MessageService,
    public confirmationService: ConfirmationService,
    private readonly urlsService: UrlsService,
    private readonly sharedHttpClientService: SharedHttpClientService,
  ) {
    this.getApplicationFilters();
    this.quickFilterEventTypeArray = this.gridService.eventTypes;
    this.getLastReportDate();
  }

  getLastReportDate() {
    let date: any;
    date = this.userService.FinraCATLastExceptionReportDate;
    this.LastExecutionCompDate = [];
    this.LastExecutionCompDate.push(date);//Fromdate
    this.LastExecutionCompDate.push(date);//Todate
  }


  defaultFilter() {
    this.LastExecutionCompDate[1]=this.LastExecutionCompDate[0];
    this.CATFieldTypesArrayList = this.userService.getDropDownList('type');
    this.deaultEventTypeValues = this.CATFieldTypesArrayList.map((rowObj: any) => rowObj.value);
    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionCompDate,"dateFilterBy":"Report Date","dateFilterValue":this.LastExecutionCompDate[0], 'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Type', 'columnname': 'Type', 'filterby': 'IS', 'values':this.deaultEventTypeValues , 'time': '', 'datatype': 'array', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList },
      { 'isdefault': 'true', 'label': 'Sample Name', 'columnname': 'sampleName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Group Name', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
    ];
  }

  sampleFilter(){
    this.LastExecutionCompDate[1]=this.LastExecutionCompDate[0];
     this.SampleFilterArray = [
       { 'isdefault': 'true', 'label': 'Sample Date *', 'columnname': 'reportDate', 'filterby': '', 'values': this.LastExecutionCompDate, "dateFilterBy":"Report Date", "dateFilterValue":this.LastExecutionCompDate[0], 'time': '', 'datatype': 'clientDataSingleDate', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '','skipFilterQuery':'true' },
      { 'isdefault': 'true', 'label': 'Sample Type(s) * ', 'columnname': 'Type', 'filterby': 'IS', 'values': this.defaultCATEvents, 'time': '', 'datatype': 'array', 'disabled': 'true', 'dropdown': 'YES', 'dropdowntype': 'multiselect', 'dropdownvalue': this.CATFieldTypesArrayList  ,'skipFilterQuery':'true'},
      { 'isdefault': 'true', 'label': 'Sample Name', 'columnname': 'sampleName', 'filterby': 'IS', 'values': this.customSampleName, 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '','isDisplay':'false','skipFilterQuery':'true'},
      { 'isdefault': 'true', 'label': 'Sample Count', 'columnname': 'sampleCount', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '','skipFilterQuery':'true' }, 
      { 'isdefault': 'true', 'label': 'Group Name', 'columnname': 'groupName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Order ID', 'columnname': 'orderID', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Symbol', 'columnname': 'symbol', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Quantity', 'columnname': 'quantity', 'filterby': '=', 'values': '', 'time': '', 'datatype': 'int', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'OrderType', 'columnname': 'orderType', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Side', 'columnname': 'side', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'ManualFlag', 'columnname': 'manualFlag', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'Boolean', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'TradingSession', 'columnname': 'tradingSession', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'HandlingInstructions', 'columnname': 'handlingInstructions', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
    ];
  }

  runComparativeReport() {
    this.LastExecutionCompDate = this.DefaultFilterArray[0]["values"];
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    payload["fileProcessType"] = "Comparative Review";
    payload["groupName"] = "ALL";
    payload["scriptType"] = "CAT";
    payload["reportType"] = "MatchedReport";
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Report_Generate), payload)
      .pipe(map((response: Response) => {
        return response;
      }));
  }

  getSamplepayload(tempFilterData:any) {
    this.LastExecutionCompDate = tempFilterData[0]["values"];
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    payload["sampleName"] = this.customSampleName;
    payload["data"] = tempFilterData;
    if (tempFilterData.length > 0) {
      for (const element of tempFilterData) {
        if (element['values'] != null && element['values'] != "") {
          payload[element['columnname']] = element['values']
          if ("reportDate".includes(element['columnname']) && tempFilterData[0].values[0] ) {
            payload["reportDate"] = this.userService.getyyyyMMddDateFormate(tempFilterData[0].values[0]);
          } else if ("Type".includes(element['columnname'])) {
            payload["Type"] = element['values'].join(',');
          }
          else if ("sampleName".includes(element['columnname'])) {
            payload[element['columnname']] = this.customSampleName;
          }else if ("Boolean".includes(element['datatype'])) {
             payload[element['columnname']] = element['values'].toLocaleLowerCase() =='true'?'1':'0';
          }
        }
      }
    }
    return payload;
  }

  generateCustomSampleRecords(tempFilterData:any) {
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Sample_Generate), this.getSamplepayload(tempFilterData))
      .pipe(map((response: Response) => {
        return response;
      }));
  }

  generateRandomSampleRecords() {
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Sample_Generate), payload)
      .pipe(map((response: Response) => {
        return response;
      }));
  }

  saveCustomSampleScheduledReport(selectedFrequency:any,selectedWeekOfMonth:any,selectedDayOfWeek:any,selectedSamples:any) {
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    payload["selectedFrequency"] = selectedFrequency;
    payload["selectedWeekOfMonth"] = selectedWeekOfMonth;
    payload["selectedDayOfWeek"] = selectedDayOfWeek;
    payload["selectedSample"] = selectedSamples.join();
    payload["isActive"] = selectedSamples.length==0?"N":"Y";
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Save_Schedule_Report_Details), payload)
      .pipe(map((response: Response) => {
        return response;
      }));
  }

    getCustomSampleScheduledReport(selectedFrequency:any) {
    let payload: any = {};
    payload["mpid"] = this.userService.getActiveMPID();
    payload["reportDate"] = this.userService.getyyyyMMddDateFormate(this.LastExecutionCompDate[0]);
    payload["user"] = this.userService.getUserFirstName();
    payload["selectedFrequency"] = selectedFrequency;
    return this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(APIURL.Comparative_Review_Get_Schedule_Report_Details), payload)
      .pipe(map((response: Response) => {
        return response;
      }));
  }

  getMatchedReportData() {
    this.LastExecutionCompDate[1] ??= this.LastExecutionCompDate[0];
    return this.gridService.getData(
      APIURL.Comparative_Review_Report,
      this.DefaultFilterArray,
      this.Limit,
      '',
      this.pageName
    ).pipe(map((response: Response) => {
      return response;
    }));
  }

  getSampleData() {
    return this.gridService.getData(
      APIURL.Comparative_Review_Sample,
      this.DefaultFilterArray,
      this.Limit,
      "",
      this.pageName
    ).pipe(map((response: Response) => {
      return response;
    }));
  }

  getApplicationFilters(filterQueryName?: any) {
    let payload = {
      mpid: this.userService.getActiveMPID(),
      application: this.pageName,
      isActive: 1
    }
    return this.gridService.getApplicationFilterQueries(payload, APIURL.GetApplicationFilterQueries);
  }

  RemoveCustomSampleFilterQuery(optedFilterQuery: any) {
    let payloadData = {
      mpid: this.userService.getActiveMPID(),
      application: this.pageName,
      id: optedFilterQuery.id,
      filterQueryName: optedFilterQuery.filter_query_name,
      usedBy: this.userService.getUserName()
    }
    return this.gridService.deleteApplicationFilterQuery(payloadData, APIURL.DeleteApplicationFilterQuery);
  }
  
}
